export const ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  HOME: '/',

  // Profile Management
  PROFILE_MANAGEMENT: '/profile/profile-management',
  PROFILE_MANAGEMENT_CUSTOMERS: '/profile/profile-management/customers',
  PROFILE_MANAGEMENT_STORES: '/profile/profile-management/stores',

  // Store View Screens
  STORE_VIEW: '/profile/store/:storeId',
  STORE_VIEW_DETAILS: '/profile/store/:storeId/activity',
  STORE_VIEW_PROFILE: '/profile/store/:storeId/profile',
  STORE_VIEW_ORDERS: '/profile/store/:storeId/campaigns',
  STORE_VIEW_PRODUCTS: '/profile/store/:storeId/orders-and-rewards',
  STORE_VIEW_PAYMENT_AND_TAX: '/profile/store/:storeId/payment-and-tax',

  // Customer View Screens
  CUSTOMER_VIEW: '/profile/customer/:customerId',
  CUSTOMER_VIEW_SETTINGS: '/profile/customer/:customerId/settings',

  // Onboarding Status
  ONBOARDING_STATUS: '/profile/onboarding-status',

  ONBOARDING_STATUS_OKTA: '/profile/onboarding-status/okta-status',
  ONBOARDING_STATUS_OKTA_ACTIVE:
    '/profile/onboarding-status/okta-status/active',
  ONBOARDING_STATUS_OKTA_LOCKED_OUT:
    '/profile/onboarding-status/okta-status/locked-out',
  ONBOARDING_STATUS_OKTA_SUSPENDED:
    '/profile/onboarding-status/okta-status/suspended',
  ONBOARDING_STATUS_OKTA_INACTIVE:
    '/profile/onboarding-status/okta-status/inactive',
  ONBOARDING_STATUS_OKTA_DEPROVISIONED:
    '/profile/onboarding-status/okta-status/deprovisioned',

  ONBOARDING_STATUS_MISSING_PRODUCT_LIST:
    '/profile/onboarding-status/missing-product-list',
  ONBOARDING_STATUS_MISSING_VISIT_LIST:
    '/profile/onboarding-status/missing-visit-list',
  ONBOARDING_STATUS_MISSING_MOA: '/profile/onboarding-status/missing-moa',
  ONBOARDING_STATUS_MISSING_CUT_OFF_TIME:
    '/profile/onboarding-status/missing-cut-off-time',
  ONBOARDING_STATUS_MISSING_DELIVERY_SERVICE:
    '/profile/onboarding-status/missing-delivery-service',

  ONBOARDING_STATUS_MISSING_PROMOTIONS:
    '/profile/onboarding-status/missing-promo-data',
  ONBOARDING_STATUS_MISSING_TARGETS:
    '/profile/onboarding-status/missing-targets-data',
  ONBOARDING_STATUS_MISSING_SEGMENTS:
    '/profile/onboarding-status/missing-segments-data',
  ONBOARDING_STATUS_MISSING_ACTIVITIES:
    '/profile/onboarding-status/missing-activity-data',

  ONBOARDING_STATUS_MISSING_MAIN_TARGETS:
    '/profile/onboarding-status/missing-main-targets-data',
  ONBOARDING_STATUS_MISSING_PRODUCT_TARGETS:
    '/profile/onboarding-status/missing-product-targets-data',

  // Error Routes
  ERROR: '/error',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',

  // Test Routes
  TEST: '/test',

  // Image
  IMAGE: 'image'
};
